import { render, staticRenderFns } from "./PrivacyPolicyView.vue?vue&type=template&id=1b83394b&scoped=true"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyView.vue?vue&type=style&index=0&id=1b83394b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b83394b",
  null
  
)

export default component.exports